/* eslint semi: 1 */
export const ACTIVATION_ROW_ACTIONS = {
  DOWNLOAD: 'download',
  RESTORE: 'restore',
  SUSPEND: 'suspend',
  PROCESSING: 'processing',
  WAITING_FOR_PLAYER_TO_CONNECT: 'waitingForPlayerToConnect'
};
